module.exports = __webpack_public_path__ + "images/41d927b08ab016d3bb8ce1fb8bf35462-IMG_5174.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_5174.jpg
// module id = ./src/assets/images/slides/living2/IMG_5174.jpg
// module chunks = 0